import {Destroyable} from '../common';
import {ChangedItem, EVENT_LISTENER_ORDER, IModelEventTarget, KeyValueListener} from './event.interface';


export class ModelEventTarget extends Destroyable implements IModelEventTarget {
  private _map: Map<string, Array<KeyValueListener>>;

  constructor() {
    super();
    this._map = new Map();
    this.onDestroy(() => {
      if (this._map) {
        this._map.clear();
        this._map = null;
      }
    }, EVENT_LISTENER_ORDER);
  }

  /**
   * 监听属性变化
   * @param {string} propertyName  "color color.add color.delete"
   * @param {KeyValueListener} listener
   * @returns {this}
   */
  register(propertyName: string, listener: KeyValueListener) {
    if (this.usable && arguments.length === 2) {
      const nameArray = propertyName
        .trim()
        .replace(/\s+/g, ' ')
        .split(' ');
      nameArray.forEach((name) => {
        if (this._map.has(name)) {
          this._map.get(name).push(listener);
        } else {
          this._map.set(name, [listener]);
        }
      });
    }
    return this;
  }

  /**
   * 撤销对属性的监听
   * @param propertyName
   * @param listener
   */
  revoke(propertyName: string, listener?: KeyValueListener) {
    if (this.usable && this._map.has(propertyName)) {
      const listenerArray = this._map.get(propertyName);
      if (!!listener && listenerArray.includes(listener)) {
        listenerArray.splice(listenerArray.indexOf(listener), 1);
      } else {
        this._map.delete(propertyName);
      }
    }
  }

  /**
   * 该方法的存在  使得外部能够触发事件
   * @param item
   */
  trigger(item: ChangedItem | Array<ChangedItem>) {
    if (this.usable) {
      if (Array.isArray(item)) {
        this._batchTrigger(item);
      } else if (!!item) {
        this._trigger(item);
      }
    }
  }


  protected _trigger(item: ChangedItem) {
    const {key, oldValue, newValue, option} = item;
    if (this.usable && this._map.has(key)) {
      this._map.get(key).forEach((listener) => {
        try {
          listener(key, oldValue, newValue, option);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }

  /**
   * 批量触发属性变化事件
   * @param changedItemArray
   * @private
   */
  protected _batchTrigger(changedItemArray: Array<ChangedItem>) {
    this.usable && changedItemArray.forEach((value) => {
      this._trigger(value);
    });
  }

}







